import { render, staticRenderFns } from "./MultiContent.vue?vue&type=template&id=8f88b9e8&scoped=true"
import script from "./MultiContent.vue?vue&type=script&lang=js"
export * from "./MultiContent.vue?vue&type=script&lang=js"
import style0 from "./MultiContent.vue?vue&type=style&index=0&id=8f88b9e8&prod&lang=scss"
import style1 from "./MultiContent.vue?vue&type=style&index=1&id=8f88b9e8&prod&lang=scss&scoped=true"
import style2 from "./MultiContent.vue?vue&type=style&index=2&id=8f88b9e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f88b9e8",
  null
  
)

export default component.exports